import { clearFilterParams, useCleanFilterForRequest } from '@btime/react-contexts'
import { gql } from '@apollo/client'
import { mergeDeepLeft, pick } from 'ramda'
import React from 'react'

import { formsClient } from '../../../../../../utils/apollo/api'
import { useQuery } from '../../../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../../../packages/kiti/components/helpers/StatePresenter'

const Context = React.createContext([])
const { Provider } = Context
export const useFormRepliesCounterState = () => React.useContext(Context)
export const useFormRepliesCounter = () => useFormRepliesCounterState()?.formRepliesCount
export const useAllFormRepliesCounter = () => useFormRepliesCounterState()?.all

const QUERY = gql`
  query FormRepliesCount($filter: FormReplyFilter, $fixedFilter: FormReplyFilter) {
    formRepliesCount(filter: $filter)
    all: formRepliesCount(filter: $fixedFilter)
  }
`

const FormRepliesCounterLoader = ({ widget, children }) => {
  const widgetFilter = clearFilterParams(widget.data?.filters || []) || {}
  const ignoreDate = widget?.data?.ignoreDate
  const { date, ...manualFilter } = pick(['date', 'placeIds'], useCleanFilterForRequest() || {})
  const insertedAt = !ignoreDate ? date : undefined
  const fullFilter = mergeDeepLeft(widgetFilter, manualFilter)

  const { data, ...state } = useQuery(QUERY, {
    variables: { filter: { ...fullFilter, insertedAt }, fixedFilter: { ...manualFilter, insertedAt } },
    client: formsClient
  })

  return (
    <StatePresenter {...state}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default FormRepliesCounterLoader
